<template>
  <div v-show="pageLoading" class="pageLoaing">
    <van-loading
      class="spinner"
      size="24px"
      color="#ff6538"
      type="spinner"
    />
  </div>
</template>

<script>
export default {
  name: 'PageLoading',
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.pageLoaing {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top:0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgb(0 0 0 / 50%);
}
</style>
